export enum RelationQueryType {
  Bookmark = "Bookmark",
  All = "All",
  TopOfDocument = "TopOfDocument"
}
